import { emailRegex } from './regex';

// Check that the input is a valid email.
const emailValidation = value =>
	value && !value.match(emailRegex) ? 'Not a valid email' : undefined;

export default emailValidation;
